import React from 'react';

import i18n from 'util/i18n';

import { getYearsString } from 'helpers/text';

import ValidationElement, {
  ValidationElementProps,
} from 'components/Form/ValidationElement/ValidationElement';
import { HistoryEmploymentItemModel } from 'forms/sections/history/employment/types';
import {
  CommonOnUpdate, CommonOnError, CommonScrollIntoView, CommonRequired
} from 'types/props';
import BranchCollection from 'components/Form/BranchCollection';
import { FieldModel } from 'forms/shared/types';
import Comments from 'components/Form/Comments';
import ReprimandItem from './ReprimandItem';

type ReprimandType = HistoryEmploymentItemModel['Reprimand']

interface Props extends ValidationElementProps, ReprimandType {
  hideGivenByEmail?: boolean,
  hideGivenByTelephone?: boolean,
  hideDateDay?: boolean,
  showConsequences?: boolean,
  showGivenByRank?: boolean,
  useMilitaryDisciplineActions?: boolean,
  onUpdate?: CommonOnUpdate
  recordYears?: number
  onError?: CommonOnError
  scrollIntoView?: CommonScrollIntoView
  required?: CommonRequired
  attribute?: string
  ReprimandAnswerComments?: FieldModel
  ReprimandComments?: FieldModel
  activity?: string
  branchLabel?: string
  appendLabel?: string
}

export default class Reprimand extends ValidationElement<Props> {
  updateReasons = (values: ReprimandType) => {
    this.props.onUpdate({
      ...values,
    });
  };

  branchComment = () => (
    <Comments
      title={i18n.t(`history.employment.default.reprimand.ReprimandAnswerComments`)}
      name="ReprimandAnswerComments"
      attribute="ReprimandAnswerComments"
      className="optional-comments"
      {...this.props.ReprimandAnswerComments}
      onUpdate={this.props.updateReprimandAnswerComments}
      onError={this.props.onError}
      required={false}
    />
  );

  render() {
    const { recordYears } = this.props;
    const recordYearsString = getYearsString(recordYears);

    return (
      <BranchCollection
          // attribute={setAttribute(this.props.attribute, 'branch.value')}
        label={this.props.branchLabel}
        appendLabel={this.props.appendLabel}
        help="history.pvq.employment.default.reprimand.help"
        {...this.props}
        className="reprimand-branch"
        onUpdate={this.updateReasons}
        onError={this.props.onError}
        required={this.props.required}
        scrollIntoView={this.props.scrollIntoView}
      >
        <ReprimandItem
          attribute={this.props.attribute}
          hideGivenByEmail={this.props.hideGivenByEmail}
          hideGivenByTelephone={this.props.hideGivenByTelephone}
          hideDateDay={this.props.hideDateDay}
          showConsequences={this.props.showConsequences}
          showGivenByRank={this.props.showGivenByRank}
          useMilitaryDisciplineActions={this.props.useMilitaryDisciplineActions}
          name="Item"
          bind
          required={this.props.required}
          scrollIntoView={this.props.scrollIntoView}
          Dates={this.props.Dates}
          isPVQ={this.props.isPVQ}
          activity
        />
      </BranchCollection>
    );
  }
}

Reprimand.defaultProps = {
  Reasons: { items: [] },
  Dates: {},
  ReprimandAnswerComments: {},
  activity: '',
  hideGivenByEmail: false,
  hideGivenByTelephone: false,
  hideDateDay: false,
  showConsequences: false,
  showGivenByRank: false,
  useMilitaryDisciplineActions: false,
  isPVQ: false,
  branchLabel: i18n.t('history.pvq.employment.default.reprimand.label'),
  appendLabel: i18n.t('history.pvq.employment.default.reprimand.append'),
  updateReprimandComments: () => { },
  updateReprimandAnswerComments: () => { },
  onUpdate: () => { },
  onError: (value, arr) => arr,
};
